import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, mergeMap, switchMap, tap} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {
  loadCountries,
  loadCountriesSuccess,
  loadCountriesFailure,
} from './list.actions';
import { ListService } from '../../services/list.service';

@Injectable()
export class ListEffects {

  loadCountries$ = createEffect(() => this.actions$.pipe(
    ofType(loadCountries), // Ensuring it is listening to the correct action
    // tap(() => console.log('loadCountries effect triggered')), // Logging when effect is triggered
    switchMap(() =>
      this.listService.getCountries()
        .pipe(
          // tap(data => console.log('Countries fetched:', data)), // Logging the data right after fetching
          map(data => {
            // console.log('Mapping data to success action', data); // Log data before mapping to success
            return loadCountriesSuccess({ countries: data.countries });
          }),
          catchError(error => {
            console.error('Error fetching countries:', error); // Log the error
            return of(loadCountriesFailure({ error }));
          })
        )
    )
  ));

  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private listService: ListService
  ) {}
}
